<template>
  <router-view />
</template>

<script>
export default {
  name: "App",
};
</script>

<style>
#app {
  font-family: Avenir, Helvetica, Arial, sans-serif;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  color: #2c3e50;
  width: 100%;
  height: auto;
}

/* Fix el-table alignment - ensure consistent text alignment */
.el-table th.el-table__cell,
.el-table td.el-table__cell {
  text-align: center !important;
}

.el-table th.el-table__cell > .cell,
.el-table td.el-table__cell > .cell {
  text-align: center !important;
}

/* Fix for fixed columns alignment */
.el-table__fixed,
.el-table__fixed-right {
  .el-table__cell {
    text-align: center !important;
  }
  .cell {
    text-align: center !important;
  }
}
</style>
